// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_HOMEPAGE = "Sp\u00e4\u0165 na hlavn\u00fa str\u00e1nku";
export const BLOGS_SEARCH_PLACEHOLDER = "H\u013eadaj na stene";
export const HOMEPAGE_PR_ARTICLES_TITLE = "\u010cl\u00e1nky od na\u0161ich partnerov";
export const NO_SEARCH_RESULTS_FOR = "Nena\u0161li sa \u017eiadne v\u00fdsledky vyh\u013ead\u00e1vania pre slovo";
export const PB_MENU_MY_ACTIVITY = "Zapojila som sa";
export const SEARCH_RESULTS_FOR = "V\u00fdsledky vyh\u013ead\u00e1vania pre slovo";
